import { api, apiUrl } from "../../shared/services/service";
import type {
  CronJobLogEnvironment,
  ReingestTechFormInboxRequest,
  ReingestTechFormInboxResponse,
  TechFormInboxPreviewResponse,
  TechFormInboxBodyPreview,
} from "../models/admin-monitoring.models";
import { getAdminMonitoringErrorMessage } from "./admin-monitoring.service";

// Calls only the dev-team Debug endpoint that reads mailbox attachments without importing them.
export const getTechFormInboxDebugPreview = async (
  mailbox: string,
  environment: CronJobLogEnvironment,
  imoNumber?: string,
  cursor?: string,
): Promise<TechFormInboxPreviewResponse> => {
  const response = await api.get(`${apiUrl}/admin/debug/tech-form-inbox/preview`, {
    params: {
      mailbox,
      environment,
      ...(imoNumber?.trim() ? { imoNumber: imoNumber.trim() } : {}),
      ...(cursor ? { cursor } : {}),
    },
  });

  return response.data;
};

export const getTechFormInboxDebugBody = async (
  mailbox: string,
  messageId: string,
): Promise<TechFormInboxBodyPreview> => {
  const response = await api.get(`${apiUrl}/admin/debug/tech-form-inbox/body`, {
    params: { mailbox, messageId },
  });

  return response.data;
};

// Calls only the dev-team Debug endpoint that rechecks and re-ingests selected mailbox attachments.
export const reingestTechFormInboxDebugAttachments = async (
  request: ReingestTechFormInboxRequest,
): Promise<ReingestTechFormInboxResponse> => {
  const response = await api.post(`${apiUrl}/admin/debug/tech-form-inbox/reingest`, request);

  return response.data;
};

export const getAdminTechFormInboxDebugErrorMessage = getAdminMonitoringErrorMessage;
